export default "__VITE_ASSET__BXYKBJbg__"